export const assetPath = 'https://cdn.findologic.com/login.symfony/web/js/autocomplete/assets/';
export const layoutAssistedSuggestPath = `${assetPath}LayoutAssistedSuggest/`;

export const assets = {
    iconCategory: `${layoutAssistedSuggestPath}Category.svg`,
    iconContent: `${layoutAssistedSuggestPath}Content.svg`,
    iconFilter: `${layoutAssistedSuggestPath}Filter.svg`,
    iconVendor: `${layoutAssistedSuggestPath}Manufacturer.svg`,
    iconPromotion: `${layoutAssistedSuggestPath}Promotion.svg`,
    iconSuggestion: `${layoutAssistedSuggestPath}SearchSuggestion.svg`,
    iconTopSearchQueries: `${layoutAssistedSuggestPath}TopSearchQueries.svg`,
    iconProductsTrending: `${layoutAssistedSuggestPath}Trending.svg`,
};
